/* eslint-disable */
import React, { useEffect, Fragment, useState, useCallback } from 'react'
import BackgroundHero from '../../static/images/hero-banner/massage-background.svg'
import ImageHero from '../../static/images/hero-banner/massage-image.svg'
import Mobile from '../../static/images/hero-banner/massage-banner-mobile.svg'
import HeroBanner from '../../components/hero-banner'
import SliderPhone from '../../components/slider-phone'
import WhyMassage from './why-massage'
import {
  TitleHeroBanner,
  TitleSubHeroBanner,
  TitleTag,
  TitleHeroBannerForSeo
} from '../../components/text'
import CardDownload from '../../components/card-download'
import OnDemand from './on-demand'
import MassageJoin from './massage-join'
import Testimonial from '../../components/testimonial'
import haloMassageIllust from '../../static/images/card-join/halo-massage-illus.svg'
import BackgroundImageDown from '../../static/images/massage/background-download.svg'
import Download from '../../components/download/download'
import ServiceMassage from './service-massage'
import Avatar1 from '../../static/icons/social/avatar-1.png'
import Avatar2 from '../../static/icons/social/avatar-2.png'
import Avatar3 from '../../static/icons/social/avatar-3.png'
import slide1 from '../../static/images/massage/slider/slide-1.webp'
import slide2 from '../../static/images/massage/slider/slide-2.webp'
import slide3 from '../../static/images/massage/slider/slide-3.webp'
import slide4 from '../../static/images/massage/slider/slide-4.webp'
import slide5 from '../../static/images/massage/slider/slide-5.webp'
import slide6 from '../../static/images/massage/slider/slide-6.webp'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'
import FixedServices from '../../components/services-fixed/index'
import FixedServicesResponsive from '../../components/service-fixed-responsive/index'
import PremiumMassage from './premium-massage'
import ServiceContent from '../../components/service-content'
import serviceContentConstant from '../../constants/service-content'
import ServiceProduct from '../../components/service-product'
import ServiceProductMobile from '../../components/service-product-mobile'
import { StyleDownload } from './index.styles'

const {
  serviceContentType: { HM }
} = serviceContentConstant

const schemaPage = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Reflexology, Pijat / Massage Panggilan Profesional | halojasa.com',
  description:
    'Layanan reflexology, jasa pijat dan massage panggilan online 24 jam terbaik dan terpercaya nomor 1 di Indonesia dengan terapis handal dan profesional.',
  url: 'https://halojasa.com/reflexology-massage-pijat-panggilan/',
  publisher: {
    '@type': 'Organization',
    name: 'Halo Jasa',
    logo: {
      '@type': 'ImageObject',
      url: 'https://halojasa.com/logo512.png'
    }
  },
  image: {
    '@type': 'ImageObject',
    url:
      'https://halojasa.com/blog/wp-content/uploads/2020/06/halomassage-ls.png',
    width: 1200,
    height: 630
  },
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': 'https://halojasa.com/reflexology-massage-pijat-panggilan/'
  },
  author: {
    '@type': 'Organization',
    name: 'Halo Jasa'
  },
  thumbnailUrl:
    'https://halojasa.com/static/media/pijat_panggilan_terdekat.jpeg'
}

const AboutPage = () => {
  const { t } = useTranslation()
  const [_, setActiveStick] = useState(true)

  const [nowPosition, setCurrentPosition] = useState(0)

  const trackScrolling = useCallback(() => {
    const currentScrollPos = window.pageYOffset
    if (currentScrollPos > nowPosition + 100) {
      setActiveStick(false)
    } else if (currentScrollPos < nowPosition + 200) {
      setActiveStick(true)
    }
    setCurrentPosition(currentScrollPos)
  }, [nowPosition])

  const renderContent = () => {
    if (window.innerWidth > 1023) {
      return (
        <React.Fragment>
          <ServiceMassage />
          <OnDemand />
        </React.Fragment>
      )
    }

    return <WhyMassage />
  }

  const renderSection = () => {
    if (window.innerWidth > 1023) {
      return <WhyMassage />
    }

    return <></>
  }

  useEffect(() => {
    document.addEventListener('scroll', trackScrolling)
    return () => {
      document.removeEventListener('scroll', trackScrolling)
    }
  }, [trackScrolling])

  const renderServiceProduct = () => {
    if (window.innerWidth > 1023) return <ServiceProduct content={HM} />

    return <ServiceProductMobile content={HM} />
  }

  return (
    <Fragment>
      <Helmet>
        <title>
          Reflexology, Pijat / Massage Panggilan Profesional | halojasa.com
        </title>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Layanan reflexology, jasa pijat dan massage panggilan online 24 jam terbaik dan terpercaya nomor 1 di Indonesia dengan terapis handal dan profesional."
        />
        <meta
          property="og:title"
          content="Reflexology, Pijat  / Massage Panggilan Profesional | halojasa.com"
        />
        <meta property="og:site_name" content="Halo Jasa" />
        <meta
          property="og:description"
          content="Layanan reflexology, jasa pijat dan massage panggilan online 24 jam terbaik dan terpercaya nomor 1 di Indonesia dengan terapis handal dan profesional."
        />
        <meta
          property="og:url"
          content="https://halojasa.com/reflexology-massage-pijat-panggilan/"
        />
        <meta
          property="og:image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/halomassage-ls.png"
        />
        <meta
          property="og:image:secure_url"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/halomassage-ls.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image"
          itemProp="image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/halomassage-sq.png"
        />
        <meta
          property="og:image:secure_url"
          itemProp="image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/halomassage-sq.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="300" />
        <meta property="og:image:height" content="268" />
        <meta property="og:type" content="website" />
        <meta property="fb:app_id" content="951866408583742" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@pthalojasa" />
        <meta
          name="twitter:title"
          content="Reflexology, Pijat  / Massage Panggilan Profesional | halojasa.com"
        />
        <meta
          name="twitter:description"
          content="Layanan reflexology, jasa pijat dan massage panggilan online 24 jam terbaik dan terpercaya nomor 1 di Indonesia dengan terapis handal dan profesional."
        />
        <meta
          name="twitter:image:src"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/halomassage-ls.png"
        />
        <meta
          name="keyword"
          content="Reflexology massage, massage, Refleksi Kaki, Reflexology, Jasa Massage, Refleksi terdekat"
        />
        <meta
          name="p:domain_verify"
          content="4e6fcb4deba1a02d84225fad69babc0b"
        />
        <meta
          name="thumbnail"
          content="https://halojasa.com/static/media/pijat_panggilan_terdekat.jpeg"
        />
        <link
          rel="canonical"
          href="https://halojasa.com/reflexology-massage-pijat-panggilan/"
        />

        <script async type="application/ld+json">{JSON.stringify(schemaPage)}</script>
      </Helmet>
      <HeroBanner
        title={
          <div>
            <TitleHeroBannerForSeo align="left">
              {t('pageBodyMassageJakarta.part33')}
            </TitleHeroBannerForSeo>
            <TitleHeroBanner className="hero-title uppercase" align="left">
              Halo Massage - Daily
            </TitleHeroBanner>
            <TitleHeroBanner className="hero-title uppercase" align="left">
              Urban Lifestyle Service
            </TitleHeroBanner>
          </div>
        }
        picture={{
          background: BackgroundHero,
          image: ImageHero,
          mobile: Mobile
        }}
        subTitleHeroBanner={
          <TitleSubHeroBanner
            align="left"
            className="title-sub-banner massage-color"
          >
            {t('pageBodyMassageJakarta.part1')}
          </TitleSubHeroBanner>
        }
        paragraph={
          <div>
            <p className="hero-desc">{t('pageBodyMassageJakarta.part3')}</p>
            <h2 className="hero-seo">{t('pageBodyMassageJakarta.part34')}</h2>
            <Download />
          </div>
        }
        tag={<TitleTag>#{t('pageBodyMassageJakarta.part2')}</TitleTag>}
        breadCrumb={[
          {
            name: 'Beranda',
            link: '/'
          },
          {
            name: 'Layanan Kami',
            link: '/about/'
          },
          {
            name: 'Halo Massage',
            link: false
          }
        ]}
      ></HeroBanner>

      {renderServiceProduct()}

      <div id="content-body">
        {renderSection()}

        <StyleDownload>
          <CardDownload
            contentImage={haloMassageIllust}
            boxShadow="0 10px 10px 0 rgba(255, 115, 0, 0.2)"
            border="solid 1px #e3dbff"
            backgroundImage={BackgroundImageDown}
            title={t('pageBodyMassageJakarta.part14')}
            tag={`# ${t('pageBodyMassageJakarta.part15')}`}
            desc={t('pageBodyMassageJakarta.part16')}
          />
        </StyleDownload>

        {renderContent()}

        <SliderPhone
          dataImage={[slide1, slide2, slide3, slide4, slide5, slide6]}
          dataText={[
            {
              title: 'Klik-Ikon Bergambar Halo-Massage',
              desc:
                'Pastikan kamu sudah memiliki apalikasi halo jasa kalo belum temukan di play store dan app store'
            },
            {
              title: 'Tentukan Opsi Layanan Yang Diinginkan',
              desc:
                'Pilih Layanan Premium atau Regular atau check outlet terdekat'
            },
            {
              title: 'Tentukan Durasi & Masukan Informasi Layanan',
              desc:
                'Lengkapi data pesanan, lamanya waktu dan refrensi trapis yang di inginkan'
            },
            {
              title: 'Konfirmasi Pesanan',
              desc: 'Masukan waktu dan tentukan lokasi serta metode pembayaran'
            },
            {
              title: 'Vendor Merespon & Mengkonfirmasi pesanan',
              desc:
                'Berkomunikasi dgn vendor dan custumer suport  melalui fitur chat dan call  didalam aplikasi'
            },
            {
              title: 'Beri ulasan & Favorite kan Vendor',
              desc:
                'Jangan lupa berikan rating lalu favorite kan vendor apabila kamu puas dgn layanannya'
            }
          ]}
        ></SliderPhone>
        <Testimonial
          data={[
            {
              key: 1,
              name: 'Mba Didi Arsyan',
              job: 'Socialita',
              desc: 'Aplikasi yang melengkapi gaya hidup masyarakat modern',
              avatarImage: Avatar1
            },
            {
              key: 2,
              name: 'Ibu Christine',
              job: 'Ibu rumah tangga',
              desc: 'Sangat bermanfaat dan bikin gaya hidup lebih enjoy',
              avatarImage: Avatar3
            },
            {
              key: 3,
              name: 'Bapak Beno darsono',
              job: 'Profesional',
              desc:
                'Merubah kebiasaan konvensional membantu saya memiliki waktu lebih baik',
              avatarImage: Avatar2
            },
            {
              key: 4,
              name: 'Ibu Christine',
              job: 'Ibu rumah tangga',
              desc: 'Sangat bermanfaat dan bikin gaya hidup lebih enjoy',
              avatarImage: Avatar3
            }
          ]}
        ></Testimonial>
        <MassageJoin></MassageJoin>
        <ServiceContent
          content={HM}
          isWeb={window.innerWidth > 1023 ? true : false}
        />
        {window.innerWidth > 1023 ? (
          <FixedServices></FixedServices>
        ) : (
          <FixedServicesResponsive></FixedServicesResponsive>
        )}
      </div>
    </Fragment>
  )
}

export default AboutPage
